import styled from 'styled-components';
import { Textarea } from 'react-rainbow-components';
import { color } from 'theme';
import { DIVIDER, WHITE } from '../../../constants';

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 0.5rem 0;
`;

export const ModalIconContainer = styled.div`
    width: 4rem;
    height: 4rem;
    border-radius: 1.5rem;
    background-color: ${color('brand.light')};
    display: flex;
    align-items: center;
    justify-content: center;

    > svg {
        width: 2.5rem;
        height: 2.5rem;
        color: ${color('brand.main')};
    }
`;

export const ModalTitle = styled.h1`
    font-size: 1.5rem;
    line-height: 1.75rem;
    font-weight: 400;
    text-align: center;
`;
export const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const ModalDescription = styled.p`
    font-size: 0.8rem;
    text-align: center;
    color: ${color('text.header')};
`;

export const NoteInput = styled(Textarea)`
    width: 100%;
    max-height: 460px;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 0.325rem;
    background-clip: unset;
    
    &::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
    & > div:first-child {
        width: 100%;
        border: 2px solid ${DIVIDER};
        box-shadow: none;
        border-radius: 0.325rem;
        background: ${WHITE};
        padding: 0;
    }
    textarea {
        width: 100%;
        max-height: 420px;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.5rem;
        border-radius: 0.325rem;
        padding: 0.5rem 0.875rem;
        box-sizing: border-box;

        &:focus,
        &:active {
            width: 100%;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.5rem;
            border-radius: 0.325rem;
            padding: 0.5rem 0.875rem;
        }
    }
    div[id^="error-message"] {
        align-self: flex-start;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 4px 0 0 0;
`;
